<app-admin-nav-details
pageName="App Management"
pageMessage="List of all insizon Apps"
>
  <button
    class="btn btn-primary d-flex align-items-center gap-2 add-btn"
    (click)="openAddAppModal()">
    <i class="bi bi-plus-circle"></i> Add App
  </button>
</app-admin-nav-details>

<div class="table-responsive">
  <table class="table">
    <thead>
      <tr>
        <th>#</th>
        <th>Title</th>
        <th>Description</th>
        <th>Website</th>
        <th>Store</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let app of apps; let i = index">
        <td>{{ (pageNumber - 1) * pageSize + i + 1 }}</td>
        <td>{{ app.title }}</td>
        <td>{{ app.description }}</td>
        <td>
          <a *ngIf="app.websiteUrl" [href]="app.websiteUrl" target="_blank">{{
            app.websiteUrl
          }}</a>
        </td>
        <td>
          <a *ngIf="app.storeUrl" [href]="app.storeUrl" target="_blank">{{
            app.storeUrl
          }}</a>
        </td>
        <td>
          <div class="edit-dlt-btn">
            <button class="btn edit-btn" (click)="openEditAppModal(app)">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button class="btn dlt-btn" (click)="openDeleteConfirmModal(app)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </td>
      </tr>
      <tr *ngIf="apps.length === 0">
        <td colspan="6" class="text-center text-muted">No apps found.</td>
      </tr>
    </tbody>
  </table>
</div>
<!-- Pagination Summary -->
<div
  *ngIf="totalCount > 0"
  class="d-flex justify-content-center align-items-center mt-3">
  <!-- Pagination -->
  <nav *ngIf="totalPages > 1" aria-label="App list pagination">
    <ul class="pagination pagination-sm mb-0">
      <li class="page-item" [class.disabled]="pageNumber === 1">
        <button
          class="page-link prev-btn"
          (click)="loadApps(pageNumber - 1)"
          [disabled]="pageNumber === 1">
          Previous
        </button>
      </li>
      <li
        class="page-item"
        *ngFor="let page of totalPagesArray()"
        [class.active]="page === pageNumber">
        <button class="page-link" (click)="loadApps(page)">
          {{ page }}
        </button>
      </li>
      <li class="page-item" [class.disabled]="pageNumber === totalPages">
        <button
          class="page-link next-btn"
          (click)="loadApps(pageNumber + 1)"
          [disabled]="pageNumber === totalPages">
          Next
        </button>
      </li>
    </ul>
  </nav>
</div>

<!-- Add/Edit App Modal -->
<div class="modal fade" id="appModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <form (ngSubmit)="saveApp()" #appForm="ngForm">
        <div class="modal-header">
          <h6 class="modal-title">
            {{ isEditMode ? "Edit App" : "Add New App" }}
          </h6>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body pb-0">
          <div class="mb-3">
            <label for="title" class="form-label">Title *</label>
            <input
              type="text"
              id="title"
              class="form-control"
              [(ngModel)]="currentApp.title"
              name="title"
              required />
            <div
              *ngIf="appForm.submitted && !currentApp.title"
              class="text-danger">
              Title is required.
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">Description</label>
            <textarea
              class="form-control"
              [(ngModel)]="currentApp.description"
              name="description"
              rows="3"></textarea>
          </div>
          <div class="mb-3">
            <label class="form-label">Logo URL</label>
            <input
              type="url"
              class="form-control"
              [(ngModel)]="currentApp.logoUrl"
              name="logoUrl" />
          </div>
          <div class="mb-3">
            <label class="form-label">Website URL</label>
            <input
              type="url"
              class="form-control"
              [(ngModel)]="currentApp.websiteUrl"
              name="websiteUrl" />
          </div>
          <div class="mb-3">
            <label class="form-label">Store URL</label>
            <input
              type="url"
              class="form-control"
              [(ngModel)]="currentApp.storeUrl"
              name="storeUrl" />
          </div>
          <!-- Release Order -->
          <div class="mb-3">
            <label class="filter-label">
              Release Order
            </label>
            <select class="filter-select" [(ngModel)]="currentApp.releaseOrder" (change)="onReleaseOrderChange($event)" name="releaseOrder">
              <option *ngFor="let releaseOrder of this.allReleaseOrders" [value]="releaseOrder">
                {{releaseOrder}}
              </option>
            </select>
          </div>
          <!-- Booleans -->
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" [(ngModel)]="currentApp.isAppReleased" name="appReleased-checkbox" id="appReleased-checkbox">
            <label class="form-check-label" for="appReleased-checkbox">
              IsAppReleased
            </label>
          </div>
           <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" [(ngModel)]="currentApp.isWaitListActive" name="waitlistAcitve-checkbox" id="waitlistAcitve-checkbox">
            <label class="form-check-label" for="waitlistAcitve-checkbox">
              IsWaitListActive
            </label>
          </div>
           <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" [(ngModel)]="currentApp.isBetaTestActive" name="betaTestActive-checkbox" id="betaTestActive-checkbox">
            <label class="form-check-label" for="betaTestActive-checkbox">
              IsBetaTestActive
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" [(ngModel)]="currentApp.isDeleted" name="appDeleted-checkbox" id="appDeleted-checkbox" disabled>
            <label class="form-check-label" for="appDeleted-checkbox">
              IsDeleted
            </label>
          </div>
          <p class="mt-3 pb-0">UpdateAt: <span class="text-muted">{{currentApp.updatedAt | date:"fullDate"}}</span></p>
        </div>
        <!-- Footer -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="!appForm.valid">
            {{ isEditMode ? "Update App" : "Add App" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<div
  class="modal fade"
  id="deleteConfirmModal"
  tabindex="-1"
  aria-labelledby="deleteConfirmModalLabel"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>
          Are you sure you want to delete the app
          <strong>"{{ appToDelete?.title }}"</strong>?
        </p>
        <p class="text-muted">This action cannot be undone.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-danger"
          (click)="confirmDelete()"
          [disabled]="isDeleting">
          <span
            *ngIf="isDeleting"
            class="spinner-border spinner-border-sm me-2"
            role="status"></span>
          {{ isDeleting ? "Deleting..." : "Delete App" }}
        </button>
      </div>
    </div>
  </div>
</div>
